export const vectorStores = Object.freeze({
    QDRANT: 'QDRANT',
});
